$(document).ready(function(){
  $(window).scroll(function(){
    $('[data-atc-banner-close]').trigger('click');
  });
  
  $('[data-product-atc]').click(function(){
    setTimeout(function(){
      if($('.atc-banner--container').attr('data-flyout-active') == 'true'){
        $('[data-atc-banner-close]').trigger('click');
      }
    },4000);
  });
  
  $('.live-search-form-field').click(function(){
     $('[data-atc-banner-close]').trigger('click');
    setTimeout(function(){ 
    	$('[data-live-search-input]').focus();
    },600);
    
  });
  
  $('[data-cartitem-quantity]').change(function(){
    setTimeout(function(){
  		window.location.href = '/cart';
    },1000);
  });  

 
  $('.option-value-input').click(function(){
   //alert($(this).prop('value'));
    var testvalus = $(this).prop('value');
   $('.outofstock-product-form-variantid').attr('value',testvalus)
  }); 
  
  if($('.form-options.no-js-required option:selected').attr("custom-data-variant-available") == 'false' )
  {
  	$(".in-stock-notification-form").show();
  }

  $('.cart-item--remove-link').click(function(){
    window.location.reload();
  });
  
});
